import React, { useState } from 'react';
import { Button } from '@components';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { Modal } from 'gd-design-library';
import styles from './ARPreview.module.scss';
import classNames from 'classnames/bind';
import Script from 'next/script';


const cx = classNames.bind(styles);

const CN = 'ar-preview';
const activateArButtonClassName = `${CN}__activate-ar-button`;

interface ARPreviewProps {
  modelSrc: string;
}

export const ARPreview: React.FC<ARPreviewProps> = ({ modelSrc }) => {
  const [ isModalOpen, setIsModalOpen ] = useState(false);

  return (
    <div className={ cx(CN) }>
      <Script type='module' src='https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js' />
      <Button
        variant='outlined'
        onClick={ (): void => setIsModalOpen(true) }
        iconStart={ <ViewInArIcon /> }
      >
        AR Preview
      </Button>
      <Modal
        isOpen={ isModalOpen }
        title='AR Preview'
        onClose={ (): void => setIsModalOpen(false) }
      >
        {/* @ts-expect-error - model-viewer is a web component loaded via script tag */}
        <model-viewer
          src={ modelSrc }
          alt='A 3D model'
          ar
          ar-modes='webxr scene-viewer quick-look'
          camera-controls
          auto-rotate
          shadow-intensity='1'
          ar-placement='floor'
          style={ {
            width: '100%',
            height: '600px',
            maxHeight: '100vh',
            backgroundColor: '#f0f0f0'
          } }
        >
          <Button
            slot='ar-button'
            className={ cx(activateArButtonClassName) }
            iconStart={ <ViewInArIcon /> }
          >
            Activate AR
          </Button>
          {/* @ts-expect-error - model-viewer is a web component loaded via script tag */}
        </model-viewer>
      </Modal>
    </div>
  );
};
